export default __webpack_public_path__ + "static/media/IMG-20241005-WA0037.a987e3fe.jpg";